import { lazy } from 'react'

// -------

import { routes } from 'config/app'
import { Rules } from 'config/permissions'

const ReportsListPage = lazy(() => import('./List'))
const ReportFormPage = lazy(() => import('./Form'))
const FormTypesListPage = lazy(() => import('./FormTypes'))

// -------

const route = routes.baseAdminRoute + '/reports'

// -------

export const Api = {
  formTypes: '/form-types',
  formType: '/form-types/:id',
  formTypeByCode: '/form-types/code/:code',
  activeFormTypes: '/form-types/active',
  formFilters: '/form-types/form-filters',

  reports: '/reports',
  report: '/reports/:id',
  reportApprove: '/reports/:id/approve',
  reportReject: '/reports/:id/reject',
  reportDownloadPdf: '/reports/:id/download-pdf',
  reportGeneratePdf: '/reports/:id/generate-pdf',
  reportViewPdf: '/reports/:id/view-pdf',
  reportsByFormType: '/reports/form-type/:formTypeId',
  reportsByCompany: '/reports/company/:companyId',
  reportsByStatus: '/reports/status/:status',
}

export const Routes = {
  reports: {
    index: route,
    form: `${route}/:id`,
  },
  formTypes: {
    index: `${route}/form-types`,
  }
}

// COMPONENTS
export const Components = [
  { path: Routes.reports.index, component: ReportsListPage, permission: Rules.page.reports?.index || true },
  { path: Routes.reports.form, component: ReportFormPage, permission: Rules.page.reports?.index || true },
  { path: Routes.formTypes.index, component: FormTypesListPage, permission: Rules.page.formTypes?.index || true }
]

